import 'slick-carousel';

jQuery(document).ready(function () {

    $(".vacatureslider").each(function( index ) {
        var slidercount = $(this).data('slidercount');

        $(this).slick({
            rows: 0,
            dots: false,
            arrows: true,
            infinite: true,
            adaptiveHeight: false,
            variableWidth: false,
            prevArrow: $('#btn-prev-'+slidercount),
            nextArrow: $('#btn-next-'+slidercount),
            speed: 500,
            fade: false,
            cssEase: 'linear',
            autoplay: false,
            autoplaySpeed: 5000,
            slidesToShow: 3,
            centerMode: false,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                    }
                }
            ]
        });
    });

    $(".partnerslider").each(function( index ) {
        var slidercount = $(this).data('slidercount');

        $(this).slick({
            rows: 0,
            dots: false,
            arrows: true,
            infinite: true,
            adaptiveHeight: false,
            variableWidth: false,
            //prevArrow: $('#btn-prev-'+slidercount),
            //nextArrow: $('#btn-next-'+slidercount),
            speed: 500,
            fade: false,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 4,
            centerMode: true,
            slidesToScroll: 1,
            pauseOnHover: false,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                    }
                }
            ]
        });
    });

    $(".pageslider").each(function( index ) {
        var slidercount = $(this).data('slidercount');

        $(this).slick({
            //rows: 0,
            dots: false,
            arrows: true,
            infinite: true,
            adaptiveHeight: false,
            variableWidth: false,
            prevArrow: $('#btn-prev-'+slidercount),
            nextArrow: $('#btn-next-'+slidercount),
            speed: 500,
            fade: false,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 4,
            centerMode: false,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                    }
                }
            ]
        });
    });

    $('.logoslider').slick({
        rows: 0,
        dots: false,
        arrows: false,
        infinite: true,
        adaptiveHeight: false,
        variableWidth: false,
        speed: 500,
        fade: false,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 6,
        centerMode: false,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                slidesToShow: 6,
                slidesToScroll: 1
                }
            },
            {
                breakpoint: 1200,
                settings: {
                slidesToShow: 5,
                slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                slidesToShow: 3,
                slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 1
                }
            }
        ]
    });

});